import { render, staticRenderFns } from "./totalAccounts.vue?vue&type=template&id=aab7d446&"
import script from "./totalAccounts.vue?vue&type=script&lang=js&"
export * from "./totalAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports